import React from 'react'
import Matze from '../assets/spacepowermatze.jpg'
import './Pt.css';

const PersonalTraining = () => {
  return (
    <div id='pt' className='w-full bg-white py-[9rem] px-4 md:grid-flow-row'>
        <div className='bild max-w[1240px] mx-auto flex md:grid-col-2'>

            <div className='grid flex-col justify-center'>
                <h1 className='md:text-4xl sm:text-3xl text-2xl font-bold md:pl-4 pl-2'>Personal Training & Ernährungsberatung</h1>
                <p className='font-bold md:pl-4 pl-2 p-2 md:text-3xl sm:text-2xl' style={{color:'#cc2200'}}>Vor Ort oder auch Online!</p>
                <p className='md:pl-4 pl-2 p-2 md:text-2xl sm:text-1xl'>
                  Ihr Weg zu einem gesünderen Lebensstil beginnt hier: Starten Sie noch heute Ihre Reise zu einem fitteren und gesünderen Leben. Unsere erstklassigen Personal Trainer sind bereit,
                  Sie auf Ihrem Weg zu begleiten. Kontaktieren Sie uns, um mehr über unsere Angebote im Bereich Personal Training und Ernährungsberatung zu erfahren.
                </p>
                <p className='font-bold md:pl-4 pl-2 p-2 md:text-3xl sm:text-2xl' style={{color:'#cc2200'}}>Vom Mr.Fitness Germany - Matthias Krenkler</p>
                <a
                  href='tel:+4971416856067'
                  className='w-[200px] rounded-md my-6 mx-auto py-3 text-white font-bold text-center block transition-opacity duration-200 hover:opacity-90'
                  style={{background:'#cc2200'}}
                >
                  Tel.: +49 7141 68 56 067
                </a>
                <a
                  href='tel:+491733604737'
                  className='w-[200px] rounded-md mx-auto py-3 text-white font-bold text-center block transition-opacity duration-200 hover:opacity-90'
                  style={{background:'#cc2200'}}
                >
                  Mobil: +49 173 36 04 737
                </a>
            </div>
            <div className='bild2'>
              <img className='p-3 mx-auto my-4' src={Matze} alt="Personal Trainer Matthias Krenkler" />
            </div>
        </div>
    </div>
  )
}

export default PersonalTraining
